"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Bucket {
    toJSON() {
        return new Object(this);
    }
    constructor({ id }) {
        this.id = id;
    }
}
exports.default = Bucket;
